<app-search></app-search>
<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Lista de Componentes</h1>
    </div>
    <br />
    <div class="card-header">
      <button id="" class="primary-button" appPermision="/component+c" (click)="createComponent()">
        <span class="button-content"> <mat-icon>add_circle</mat-icon> Agregar nuevo </span>
      </button>
    </div>
    <br />
    <div class="table-scroll-wrapper">
      <section class="table-container mat-elevation-z1" tabindex="0">
        <div class="table-adjustable">
          <table
            mat-table
            [dataSource]="
              (asyncComponent | async) ?? []
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: limit,
                      currentPage: page,
                      totalItems: total,
                    }
            "
          >
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let component">
                <div class="action-buttons">
                  <a
                    title="Editar"
                    class="icon-button"
                    appPermision="/component+u"
                    (click)="updateComponent(component)"
                  >
                    <span class="material-symbols-outlined"><mat-icon>edit</mat-icon></span>
                  </a>
                  <a
                    appOnlysuperuser="/component"
                    (click)="eliminate(component)"
                    class="icon-button"
                  >
                    <span class="material-symbols-outlined"><mat-icon>delete</mat-icon></span>
                  </a>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let component">
                {{ component.id }}
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Nombre</th>
              <td mat-cell *matCellDef="let component">
                {{ component.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef>Descripción</th>
              <td mat-cell *matCellDef="let component">
                {{ component.description }}
              </td>
            </ng-container>

            <ng-container matColumnDef="risk">
              <th mat-header-cell *matHeaderCellDef>Riesgo</th>
              <td mat-cell *matCellDef="let component">
                {{ component.risk }}
              </td>
            </ng-container>

            <ng-container matColumnDef="objective">
              <th mat-header-cell *matHeaderCellDef>Objetivo</th>
              <td mat-cell *matCellDef="let component">
                {{ component.objective }}
              </td>
            </ng-container>

            <ng-container matColumnDef="result">
              <th mat-header-cell *matHeaderCellDef>Resultado</th>
              <td mat-cell *matCellDef="let component">
                {{ component.result }}
              </td>
            </ng-container>

            <ng-container matColumnDef="line">
              <th mat-header-cell *matHeaderCellDef>Línea</th>
              <td mat-cell *matCellDef="let component">
                {{ component.line?.name }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: showColumns" class="highlight-row"></tr>
          </table>
        </div>
      </section>
    </div>
    <pagination-controls
      (pageChange)="fetchComponent($event)"
      previousLabel="Anterior"
      nextLabel="Siguiente"
      id="server"
    ></pagination-controls>
  </div>
</div>
